<template>
  <div class="feedback-card">
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'FeedbackCard',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback-card {
  margin-top: var(--ds-spacing-inline-sm);
  padding: var(--ds-spacing-squish-nano);
  border-radius: var(--ds-border-radius-sm);
  background: var(--ds-color-overlay);

  p {
    margin-bottom: 0;
    font-size: var(--ds-font-size-xs);
    line-height: 24px;
    color: var(--ds-color-text-1);
  }
}
</style>
